import 'angular-ui-bootstrap';

var handlersModule =  angular.module('handlers',['ui.bootstrap']);
export default handlersModule.name;